module.exports = __webpack_public_path__ + "static/media/error.b84fec81.svg";